<template>
  <el-dialog :title="editing ? '编辑监测账号' : '添加监测账号'" :visible="visible" width="520px" :close-on-click-modal="!saving" :close-on-press-escape="!saving" :show-close="!saving" @close="close">
    <el-form label-width="100px" :disabled="saving">
      <el-form-item label="平台"><el-select v-model="form.platform" :disabled="!!editing"><el-option label="B站" value="bilibili"/><el-option label="抖音" value="douyin"/></el-select></el-form-item>
      <el-form-item label="账号主页"><el-input v-model.trim="form.homepage_url" placeholder="粘贴 B站 UP 主或抖音作者主页链接"/></el-form-item>
      <el-form-item label="账号 ID"><el-input v-model.trim="form.account_id" placeholder="无法从链接识别时再填写"/></el-form-item>
      <el-form-item label="显示名称"><el-input v-model.trim="form.account_name" placeholder="可选，方便页面识别"/></el-form-item>
      <el-form-item label="自动同步"><el-switch v-model="form.enabled"/></el-form-item>
    </el-form>
    <div class="hint">添加后系统每天自动发现新增作品，并刷新该平台全部已入库作品的公开指标。</div>
    <span slot="footer"><el-button :disabled="saving" @click="close">取消</el-button><el-button type="primary" :loading="saving" @click="save">{{saving?'保存中':'保存'}}</el-button></span>
  </el-dialog>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'
const empty = () => ({ platform: 'bilibili', homepage_url: '', account_id: '', account_name: '', enabled: true })
export default {
  props: ['visible', 'editing'], data () { return { form: empty(), saving: false } },
  watch: { visible (v) { if (v) this.form = this.editing ? { ...this.editing } : empty() } },
  methods: {
    close () { if (!this.saving) this.$emit('update:visible', false) },
    async save () {
      if (this.saving) return
      if (!this.form.homepage_url) return this.$message.warning('请填写账号主页链接')
      this.saving = true
      try {
        if (this.editing) await yuqingApi.put(`creator-accounts/${this.editing.id}`, this.form)
        else await yuqingApi.post('creator-accounts', this.form)
        this.$message.success('监测账号已保存')
        this.saving = false
        this.close()
        this.$emit('success')
      } catch (e) {
        this.$message.error(e.message || '账号保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>.hint { color: #909399; line-height: 20px; margin-left: 20px }</style>
